import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg-indigo-500 dark:bg-indigo-700 lg:px-6 py-2.5 flex-none w-full relative",
  style: {
    "background": "linear-gradient(rgb(0, 31, 61), rgb(27, 58, 85))",
    "height": "3.75rem"
  }
};
const _hoisted_2 = {
  class: "flex flex-wrap lg:justify-center items-center mx-auto max-w-screen-xl"
};
const _hoisted_3 = {
  class: "lg:hidden flex items-center"
};
const _hoisted_4 = ["aria-expanded"];
const _hoisted_5 = {
  class: "hidden lg:flex lg:flex-row xl:space-x-8 lg:mt-0"
};
const _hoisted_6 = {
  class: "lg:hidden mt-2"
};
const _hoisted_7 = {
  class: "flex flex-col headbar-small-container",
  style: {
    "background": "rgb(0, 31, 61)"
  }
};
const _hoisted_8 = {
  class: "flex justify-center",
  style: {
    "position": "absolute",
    "right": "0px",
    "bottom": "0.6rem"
  }
};
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Bars3Icon = _resolveComponent("Bars3Icon");
  const _component_XMarkIcon = _resolveComponent("XMarkIcon");
  return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleMobileMenu && $options.toggleMobileMenu(...args)),
    type: "button",
    class: "inline-flex items-center p-2 text-slate-100",
    "aria-expanded": _ctx.isMobileMenuOpen
  }, [!_ctx.isMobileMenuOpen ? (_openBlock(), _createBlock(_component_Bars3Icon, {
    key: 0,
    class: "w-5 h-5"
  })) : (_openBlock(), _createBlock(_component_XMarkIcon, {
    key: 1,
    class: "w-5 h-5"
  }))], 8, _hoisted_4)]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toTop && $options.toTop(...args)),
    class: _normalizeClass(["absolute p-1 transition-all", [$options.showTopBtn ? 'opacity-100 cursor-pointer z-1' : 'opacity-0 cursor-default z-[-1]']]),
    style: {
      "left": "50%",
      "transform": "translateX(-50%)",
      "top": "0.85rem"
    }
  }, _cache[3] || (_cache[3] = [_createElementVNode("svg", {
    t: "1742544424640",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "10129",
    width: "30",
    height: "30"
  }, [_createElementVNode("path", {
    d: "M512 960C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z m0-64c212.077 0 384-171.923 384-384S724.077 128 512 128 128 299.923 128 512s171.923 384 384 384z",
    fill: "#ddd",
    "p-id": "10130"
  }), _createElementVNode("path", {
    d: "M556.343 363.098v404.333c0 22.092-17.908 40-40 40-22.091 0-40-17.908-40-40V363.087a4 4 0 0 0-6.728-2.925L326.686 493.459a8 8 0 0 1-5.655 2.342H231a4 4 0 0 1-2.828-6.828l260.256-260.257c15.621-15.621 40.948-15.621 56.569 0l250.257 260.257a4 4 0 0 1-2.828 6.828h-90.764a8 8 0 0 1-5.663-2.35L563.175 360.274a4 4 0 0 0-6.832 2.824z",
    fill: "#ffffff",
    "p-id": "10131"
  })], -1)]), 2), _createElementVNode("div", {
    class: _normalizeClass(["justify-between items-center w-full lg:flex lg:w-auto", {
      hidden: !_ctx.isMobileMenuOpen
    }])
  }, [_createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "default")])])], 2)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    class: "btn inline-flex items-center justify-center rounded-full px-3 py-2 text-white transition-colors duration-200",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.toggleLanguage && $options.toggleLanguage(...args))
  }, [_createElementVNode("div", {
    innerHTML: $options.dynamicSVG,
    class: "pr-1"
  }, null, 8, _hoisted_9), _createTextVNode(" " + _toDisplayString($options.isEnglish ? "中文" : "English"), 1)])])]);
}